import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';

import { connect } from 'react-redux';
import DirectsList from './directsList';
import preloaderWhileLoading from '../../../../utils/enchancers/preloaderWhileLoading';
import { PRELOADER_DIMENSION } from '../../../../constants/ui';
// import mapStateToProps from "react-redux/es/connect/mapStateToProps";
import { messengerSelectors } from '../../../../state/messenger';

const mapStateToProps = state => ({
  isPending: messengerSelectors.getDirectChannelsPending(state),
});

const enhance = compose(
  connect(mapStateToProps),
  withNamespaces(['common', 'chat']),
  preloaderWhileLoading({
    dimension: PRELOADER_DIMENSION.EXTRA_SMALL,
    alignContainerCenter: true,
    delay: 600,
    isLoading: () => false,
    onAction: ({ isPending }) => isPending,
  }),
);

export default enhance(DirectsList);
